import { encodePeriodValue, GlobalPeriodSelect } from '@components'

import { ReactElement, useCallback } from 'react'

import { PeriodValue } from '../../../../../../../../types/periodValue'
import { useQuotesList } from '../../../../context/quotesList'
import { useQuotesListFilters } from '../../../../context/quotesListFilters'
import * as Styled from './styles'

export const QuotesPeriodSelector = (): ReactElement => {
  const { organization } = useQuotesList()
  const [{ period: queryParamPeriod }, setFilters] = useQuotesListFilters()
  const organizationId = organization?.id

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organizationId) {
        return
      }

      setFilters({ period: encodePeriodValue(periodValue, organizationId), page: 1 })
    },
    [organizationId, setFilters],
  )

  return (
    <Styled.QuotesPeriodSelector>
      <GlobalPeriodSelect encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} placement="bottom-end" />
    </Styled.QuotesPeriodSelector>
  )
}
